import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFound = () => {
  // Animation variants for text
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: 0.8, 
        ease: "easeOut" 
      }
    }
  };

  // Animation variants for the numbers
  const numberVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: {
      scale: 1,
      rotate: 0,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 20,
        duration: 1
      }
    }
  };

  // Hover animation for the button
  const buttonVariants = {
    hover: {
      scale: 1.05,
      transition: {
        duration: 0.2,
        yoyo: Infinity
      }
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4">
      {/* Main content container */}
      <div className="text-center">
        {/* Animated 404 numbers */}
        <motion.div 
          className="flex justify-center items-center gap-4 mb-8"
          initial="hidden"
          animate="visible"
        >
          {['4', '0', '4'].map((num, index) => (
            <motion.span
              key={index}
              variants={numberVariants}
              className="text-9xl font-bold"
              style={{
                color: index === 1 ? '#FED700' : 'red'
              }}
              custom={index}
            >
              {num}
            </motion.span>
          ))}
        </motion.div>

        {/* Animated text */}
        <motion.h2
          variants={textVariants}
          initial="hidden"
          animate="visible"
          className="text-white text-2xl md:text-4xl font-bold mb-4"
        >
          Oops! Page Not Found
        </motion.h2>

        <motion.p
          variants={textVariants}
          initial="hidden"
          animate="visible"
          className="text-white mb-8 max-w-md mx-auto"
        >
          The page you're looking for seems to have wandered off into the digital void.
        </motion.p>

        {/* Animated button */}
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
        >
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-white text-black px-6 py-3 rounded-full font-semibold hover:bg-blue-300 transition-colors"
          >
            <Home size={20} />
            Back to Home
          </Link>
        </motion.div>
      </div>

      {/* Background decoration */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,#FED700_0%,transparent_70%)]" />
      </motion.div>
    </div>
  );
};

export default NotFound;